import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { POLICIES } from '../data/policies';

const policyMeta = {
  terms: { title: 'Terms of Service', lastUpdated: 'December 2025' },
  privacy: { title: 'Privacy Policy', lastUpdated: 'December 2025' },
  refunds: { title: 'Refund Policy', lastUpdated: 'December 2025' },
  turnaround: { title: 'Turnaround Policy', lastUpdated: 'December 2025' },
  revisions: { title: 'Revision Policy', lastUpdated: 'December 2025' },
  disclaimers: { title: 'Service Disclaimers', lastUpdated: 'December 2025' },
  apply_assist: { title: 'Application Support Terms', lastUpdated: 'December 2025' }
};

export default function PolicyPage() {
  const { policyKey } = useParams();
  const policy = POLICIES[policyKey];
  const meta = policyMeta[policyKey] || { title: 'Policy', lastUpdated: 'December 2025' };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <main className="pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6">
          {/* Breadcrumb */}
          <div className="mb-8">
            <nav className="text-sm text-slate-500">
              <Link to="/" className="hover:text-teal-600">Home</Link>
              <span className="mx-2">/</span>
              <span className="text-slate-900">Policies</span>
              <span className="mx-2">/</span>
              <span className="text-slate-900">{meta.title}</span>
            </nav>
          </div>

          <Card className="p-8 md:p-12 rounded-3xl" data-testid="policy-content">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>
              {policy?.title || meta.title}
            </h1>
            <p className="text-slate-500 text-sm mb-8">Last updated: {meta.lastUpdated}</p>

            <div className="prose prose-slate max-w-none">
              {policy?.content ? (
                <div className="whitespace-pre-wrap text-slate-700 leading-relaxed">
                  {policy.content}
                </div>
              ) : (
                <p className="text-slate-500">Policy content not found.</p>
              )}
            </div>
          </Card>

          {/* Other Policies */}
          <div className="mt-8">
            <h3 className="font-semibold text-slate-900 mb-4">Other Policies</h3>
            <div className="flex flex-wrap gap-2">
              {Object.entries(policyMeta).filter(([key]) => key !== policyKey).map(([key, val]) => (
                <Link 
                  key={key}
                  to={`/policies/${key}`}
                  className="text-sm text-teal-600 hover:text-teal-700 px-3 py-1 bg-teal-50 rounded-full"
                >
                  {val.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
